import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { AuthLogo } from '@/components/auth/AuthLayouts';
import { getDefaultHomePath } from '@/utils/redirectByRole';

export default function NotFoundPage() {
  const { user } = useAuth();
  const homePath = user ? getDefaultHomePath(user.role, user.slug) : '/';

  return (
    <div className="flex min-h-dvh flex-col bg-gc-50 pb-safe">
      <div className="flex min-h-auth-hero-safe items-center justify-center bg-primary-500 px-4">
        <AuthLogo className="h-10 w-auto brightness-0 invert" />
      </div>
      <div className="relative z-10 -mt-6 flex flex-1 flex-col items-center rounded-t-3xl bg-white px-5 pt-10 pb-8 text-center">
        <h1 className="mb-2 text-xl font-bold text-gc-900">Halaman tidak ditemukan</h1>
        <p className="mb-8 max-w-sm text-sm text-gc-500">
          Halaman yang Anda cari tidak ada atau sudah dipindahkan.
        </p>
        <Link
          to={homePath}
          className="inline-flex items-center justify-center rounded-xl bg-primary-500 px-8 py-3 text-sm font-semibold text-white"
        >
          Kembali ke Beranda
        </Link>
      </div>
    </div>
  );
}
